import { render, staticRenderFns } from "./SchoolContent.vue?vue&type=template&id=9ddf65f4&scoped=true&"
import script from "./SchoolContent.vue?vue&type=script&lang=js&"
export * from "./SchoolContent.vue?vue&type=script&lang=js&"
import style0 from "./SchoolContent.vue?vue&type=style&index=0&id=9ddf65f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddf65f4",
  null
  
)

export default component.exports